<template>
  <div class="cert-nav-dropdown" :class="`${closedClass} ${active?'active':''} ${accent ? 'cert-accent':''}`">
    <div @click="toggleActive()" class="my-auto ml-0 ml-xl-auto">{{ title }}</div>
    <micon class="my-auto mr-auto" icon="arrow_drop_down"/>
    <div class="cert-dropdown">
      <div v-for="(item,index) in links" :key="index" class="cert-dropdown-item d-flex flex-row"
           @click="onLinkClick(item,index)">
        <a v-if="item.external" :ref="title+index" target="_blank" :href="'//'+item.path" style="display: none"></a>
        <span>{{ item.title }}</span>
        <micon v-if="item.external" class="ml-auto px-2 my-auto"
               :icon="item.icon!=null?item.icon:'launch'"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertNavDropDown",
  props: {
    title: String,
    links: Array,
    accent: Boolean,
    requestClose: Function,
  },
  data() {
    return {
      closedClass: "",
      active: false,
    };
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
      if(!this.active)
        this.close();
    },
    close() {
      this.active=false;
      this.requestClose();
      this.closedClass = "closed";
      setTimeout(() => {
        this.closedClass = ""
      }, 100);
    },
    onLinkClick(item, index) {
      this.close();
      if (!item.external)
        this.$router.push({path: item.path});
      else {
        let el = this.$refs[this.title + index];
        el.click();
      }
    }
  }
}
</script>
